import { Component, Input, OnInit } from '@angular/core';
import { DataService } from '../services/data.service';
import { ToasterService, CoreImageViewService } from '../services';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ConfirmModalComponent } from '../modals';

@Component({
  selector: 'app-core-image-list',
  templateUrl: './core-image-list.component.html',
})
export class CoreImageListComponent implements OnInit {
  @Input() entityType: string = '';
  @Input() entityId: number = 0;
  @Input() editable: boolean = false;

  images: any[] = [];
  deletingImageIds: Set<number> = new Set();
  isLoading: boolean = false;
  bsModalRef?: BsModalRef;

  constructor(
    private dataService: DataService,
    private toastr: ToasterService,
    private bsModalService: BsModalService,
    private coreImageView: CoreImageViewService
  ) {}

  ngOnInit(): void {
    this.fetchImages();
  }

  private fetchImages(): void {
    this.isLoading = true;
    this.dataService
      .get(`api/core/images/${this.entityType}/${this.entityId}`)
      .subscribe(
        (images: any[]) => {
          this.images = images;
          this.isLoading = false;
        },
        (err) => {
          this.isLoading = false;
          this.toastr.showError('messages.error');
        },
        () => {
          this.isLoading = false;
        }
      );
  }

  /**
   * Re-fetch images from the server. Call this after an upload or other
   * mutation to keep the list in sync.
   */
  reload(): void {
    this.fetchImages();
  }

  deleteImage(image: any): void {
    this.bsModalRef = this.bsModalService.show(ConfirmModalComponent, {
      initialState: {
        title: 'navigations.delete',
        content: '',
      },
    });
    this.bsModalRef.content.confirmFn = () => {
      this.deletingImageIds.add(image.id);
      this.dataService.delete('api/core/images', image.id).subscribe({
        next: () => {
          this.images = this.images.filter((i) => i.id !== image.id);
          this.deletingImageIds.delete(image.id);
          this.coreImageView.invalidateCache(this.entityType, this.entityId);
          this.toastr.showSuccess('messages.delete');
        },
        error: () => {
          this.deletingImageIds.delete(image.id);
        },
      });
      this.bsModalRef?.hide();
    };
    this.bsModalRef.content.cancelFn = () => {
      this.bsModalRef?.hide();
    };
  }

  isDeleting(imageId: number): boolean {
    return this.deletingImageIds.has(imageId);
  }
}
